import { jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12C1 5.92487 5.92487 1 12 1C18.0752 1 23 5.92487 23 12C23 18.0752 18.0752 23 12 23C5.92487 23 1 18.0752 1 12ZM17.1473 9.98449C17.447 9.68482 17.447 9.1989 17.1473 8.8992C16.8476 8.5995 16.3617 8.5995 16.062 8.8992L10.9767 13.9844L8.96127 11.969C8.66157 11.6693 8.17564 11.6693 7.87594 11.969C7.57624 12.2687 7.57624 12.7545 7.87594 13.0543L10.4341 15.6124C10.578 15.7564 10.7732 15.8372 10.9767 15.8372C11.1803 15.8372 11.3755 15.7564 11.5194 15.6124L17.1473 9.98449Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
